import { render, staticRenderFns } from "./descriptive-btn.vue?vue&type=template&id=22ef65c8"
import script from "./descriptive-btn.vue?vue&type=script&lang=js"
export * from "./descriptive-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports